module.exports = __webpack_public_path__ + "static/media/captivating-thumbnail1.735c4d96.png";